import React from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { hasDepartmentName } from "../atoms/atoms";
import { useRecoilState } from "recoil";

export const MakeDetails: React.FC = () => {
  const formMethods = useFormContext();
  const [, setHasDepartmentName] = useRecoilState(hasDepartmentName);

  const handleInputChange = (event) => {
    const value = event.target.value.trim();
    if (value !== "") {
      setHasDepartmentName(true);
    } else {
      setHasDepartmentName(false);
    }
  };

  return (
    <>
      <div className="bg-bgDB mr-3 pb-1">
        <div className="bg-white shadow-lg h-full">
          <div className="">
            <div className="grid grid-cols-6 mx-3 pb-2 gap-6 py-2">
              <div className="col-span-2 my-1">
                <TextInputLabelHookForm
                  name="officeDepartmentName"
                  label="Office Department Name"
                  type="text"
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  className={
                    formMethods.formState.errors.officeDepartmentName &&
                    formMethods.formState.errors.officeDepartmentName.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={formMethods.register("officeDepartmentName", {
                    required: {
                      value: true,
                      message: "Required Field",
                    },
                  })}
                  maxLength={150}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MakeDetails;
